var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.325,
    height: 21.628,
    viewBox: "0 0 24.325 21.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_9_1",
    "data-name": "Component 9 \\u2013 1",
    transform: "translate(0.427 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M12.163,10.063v4.425a14.382,14.382,0,0,1-11.735.18v-4.6A3.251,3.251,0,0,1,3.678,6.81h5.23a3.254,3.254,0,0,1,3.256,3.251Z",
    transform: "translate(-0.428 -1.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M12.163,10.063v4.425a14.382,14.382,0,0,1-11.735.18v-4.6A3.251,3.251,0,0,1,3.678,6.81h5.23a3.254,3.254,0,0,1,3.256,3.251Z",
    transform: "translate(-0.428 -1.389)",
    fill: "none",
    stroke: "#868686",
    strokeWidth: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M6.751.427A3.27,3.27,0,1,1,3.481,3.7,3.27,3.27,0,0,1,6.751.427",
    transform: "translate(-0.884 -0.427)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M25.965,10.07v4.425a14.382,14.382,0,0,1-11.735.18v-4.6a3.251,3.251,0,0,1,3.25-3.253h5.23a3.254,3.254,0,0,1,3.256,3.251Z",
    transform: "translate(-2.495 -1.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M25.965,10.07v4.425a14.382,14.382,0,0,1-11.735.18v-4.6a3.251,3.251,0,0,1,3.25-3.253h5.23a3.254,3.254,0,0,1,3.256,3.251Z",
    transform: "translate(-2.495 -1.39)",
    fill: "none",
    stroke: "#868686",
    strokeWidth: 0.855
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M20.553.434a3.27,3.27,0,1,1-3.27,3.27,3.27,3.27,0,0,1,3.27-3.27",
    transform: "translate(-2.952 -0.434)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M19.555,17.266v4.425a14.382,14.382,0,0,1-11.735.18v-4.6a3.251,3.251,0,0,1,3.25-3.253H16.3a3.254,3.254,0,0,1,3.256,3.251Z",
    transform: "translate(-1.535 -2.468)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M14.143,7.631a3.27,3.27,0,1,1-3.27,3.27,3.27,3.27,0,0,1,3.27-3.27",
    transform: "translate(-1.992 -1.512)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsIcon);
export default __webpack_public_path__ + "static/media/groups_icon.217eed22e75d280e6dde362e49853d82.svg";
export { ForwardRef as ReactComponent };